export type ApiKeyStatus = 'active' | 'rotating' | 'expired' | 'revoked';

export interface ApiKey {
  id: string;
  name: string;
  prefix: string;
  scopes: string[];
  status: ApiKeyStatus;
  createdAt: string | null;
  lastUsedAt: string | null;
  graceUntil: string | null;
  rotatedTo: string | null;
}

export interface ApiKeyWithSecret extends ApiKey {
  secret: string;
  previous?: ApiKey;
}

/** Alcances de `API_KEY_SCOPES` en qrcl/api/deps.py (todas las operaciones salvo miembros y API keys). */
export const SCOPES: { value: string; label: string }[] = [
  { value: 'view_qrs', label: 'Leer QR e inventario' },
  { value: 'create_digital_qr', label: 'Crear QR digitales' },
  { value: 'edit_destination', label: 'Editar destino' },
  { value: 'activate_qr', label: 'Activar QR físicos' },
  { value: 'manage_lots', label: 'Pedir lotes y marcar impresos' },
  { value: 'manage_custody', label: 'Asignar custodia' },
  { value: 'suspend_qr', label: 'Suspender y reactivar QR' },
  { value: 'view_audit', label: 'Leer auditoría' },
  { value: 'configure_partner_page', label: 'Configurar página del partner' },
];

export function scopeLabel(value: string): string {
  return SCOPES.find((s) => s.value === value)?.label ?? value;
}
